jQuery(document).ready(function( $ ) {
	
	ld_site();
	
	function ld_site() {

		////////////////////////////////////////////////////////////////////////////////////////////////
		// 1 - joints_native
		////////////////////////////////////////////////////////////////////////////////////////////////
		$.joints_native();
		
		////////////////////////////////////////////////////////////////////////////////////////////////
		// 2 - client_scripts_visual
		////////////////////////////////////////////////////////////////////////////////////////////////
		$.client_scripts_visual();
		
		$(window).resize(function() {
			$.client_scripts_visual();
			$.ld_debug('resized2');
		});
		
		////////////////////////////////////////////////////////////////////////////////////////////////
		// 3 - client_scripts_functionality
		////////////////////////////////////////////////////////////////////////////////////////////////
		$.client_scripts_functionality();
		
		////////////////////////////////////////////////////////////////////////////////////////////////
		// 4 - client_scripts_user_events
		////////////////////////////////////////////////////////////////////////////////////////////////		
		$.client_scripts_user_events();

	}
	
});